import { GoogleDriveService } from './services/google-drive.service';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { Folder, Document } from './models/node.class';
import { Subject, takeUntil } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { FormatSizePipe } from '../../../../pipe/format-size.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { FolderComponent } from './components/folder/folder.component';
import { NgFor, NgIf, NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'app-media-kit',
    templateUrl: './media-kit.component.html',
    styleUrls: ['./media-kit.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        FolderComponent,
        NgIf,
        NgClass,
        DatePipe,
        TranslateModule,
        FormatSizePipe,
    ],
})
export class MediaKitComponent implements OnDestroy {
  // Main Config move to env plz
  DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';
  API_KEY = 'AIzaSyA_cmmJujEj8GgAEcchJbpahhEWYdQs4go';
  ROOT_DRIVE_ID = '1r6TMfldGjxXc6q_LeYUXlRMaKVOLAENw';

  FOLDER_MIME_NAME = 'application/vnd.google-apps.folder';

  private $unsubscribe = new Subject<void>();

  driveStructure: (Folder | null)[] = [];
  dataStructure: (Folder | Document | null)[] = [];
  content: (Document | null)[] = [];
  title: string;

  // Pagination
  index = 0;
  maxPage = 0;
  filesPerPage = 9;

  // List & Grid
  listActive = false;
  gridActive = true;

  // Adaptative
  mobileMode = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setMobileMode(event.target.innerWidth)
  }

  constructor(private gapiService: GoogleDriveService, public sanitizer: DomSanitizer) {
    this.gapiService._driveStructure
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((folders) => {
        this.driveStructure = folders;
      });

    this.gapiService._mainViewStructure
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((nodes) => {
        this.dataStructure = nodes;
        this.index = 0;
        this.paginate(this.index);
      });

    this.gapiService._activeFolderName
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((title) => (this.title = title));

    this.setMobileMode(window.innerWidth);

  }

  setMobileMode(size: number) {
    if(size < 700) {
        this.mobileMode = true;
        this.listActive = true;
        this.gridActive = false;
    } else {
        this.mobileMode = false;
    }
  }
  dowloadFile(file) {
    window.open(file.data.webContentLink);
  }

  paginate(index) {
    if (!this.dataStructure) return;

    this.maxPage = Math.ceil(this.dataStructure.length / this.filesPerPage);
    this.content = this.dataStructure.slice(
      index * this.filesPerPage,
      (index * this.filesPerPage) + this.filesPerPage
    );
    // Update the index for the css
    this.index = index;
  }

  getIcon(item): string {
    const ext = item.data.name.split('.')[item.data.name.split('.').length - 1].toLowerCase();
    if(ext === 'png' || ext === 'jpg' || ext === 'jpeg') {
      return 'image'
    } else if (ext === 'mp4') {
      return 'video';
    } else if(ext === 'otf' || ext === 'ttf') {
        return 'font';
    } else if(ext === 'pdf') {
        return 'pdf';
    } else {
        return 'svg';
    }
  }

  changeStyle(value: string) {
    switch(value) {
      case 'list':
        this.listActive = true
        this.gridActive = false
        this.filesPerPage = 7;
        break;

      case 'grid':
        this.listActive = false
        this.gridActive = true
        this.filesPerPage = 9;
        break;
    }
    this.paginate(0);
  }

  getThumbnails(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
